import React from 'react';
import './header.css';
import Image from './image';

function MenuItemWithDropdown({ title, submenu, className }) {
  return (
    <li className={className} key={title}>
      <div className="dropdown-title">{title}</div>
      <ul>
        {submenu.map(({ className, link, title }) => (
          <li key={link}>
            <a className={className} href={link}>
              {title}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
}

export default function Header({ prepend = '/', showLink = true }) {
  return (
    <nav className="mainNav">
      <ul>
        <li className="home_link_li">
          <a className="home_link" href={`/`}>
            {showLink ? (
              <Image
                src={`logo-bsp.png`}
                alt="letter B with lighting bolt"
                height="35px"
              />
            ) : null}
          </a>
        </li>
        <MenuItemWithDropdown
          title="Commercial - Industrial"
          className="BigLink"
          submenu={[
            {
              title: 'Power Metered Panels',
              className: 'pmp_link',
              link: `${prepend}pmp/`,
            },
            {
              title: 'Lighting Control Panels',
              className: 'bcp_link',
              link: `${prepend}bcp-commercial/`,
            },
            {
              title: 'Retrofits',
              className: 'retrofits_link',
              link: `${prepend}retrofits/`,
            },
            {
              title: 'Metered Switchboards',
              className: 'pms_link',
              link: `${prepend}pms/`,
            },
          ]}
        />
        <MenuItemWithDropdown
          title="Performance Lighting"
          className="BigLink"
          submenu={[
            {
              title: 'DMX Controlled Panels',
              className: 'dmx_link',
              link: `${prepend}bcp-theater/`,
            },
            {
              title: 'Portable Distro Panels',
              className: 'touring',
              link: `${prepend}touring/`,
            },
            {
              title: 'Retrofits',
              className: 'retrofits_theater_link',
              link: `${prepend}retrofits-theater/`,
            },
            {
              title: 'Smart Contactor',
              link: '/bsc/',
            },
            {
              title: 'RDM Tester Software',
              className: 'rdm_link',
              link: `${prepend}rdm/`,
            },
          ]}
        />
        <li>
          <a href={`${prepend}digital-signage/`}>Signage</a>
        </li>
        <li>
          <a href={`${prepend}horticulture/`}>Horticulture</a>
        </li>
        <li>
          <a className="downloads_link" href={`${prepend}downloads/`}>
            Downloads
          </a>
        </li>
        <li className="last_nav">
          <a className="contact_link" href={`${prepend}contact/`}>
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
}
